import { format } from 'date-fns'
import moment from 'moment-timezone'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

export const caseCountsColumns: GridColDef[] = [
  {
    field: 'first_name',
    headerName: 'Pathologist',
    width: 460,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'case_count',
    headerName: 'Case Count',
    width: 440,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.case_count}`,
  },
  {
    field: 'date',
    headerName: 'Date',
    width: 460,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => (params.row.date ? getFormattedDateForCaseCount(params.row.date) : ''),
  },
]

export const loadBalancerColumns: GridColDef[] = [
  {
    field: 'runId',
    headerName: 'Run ID',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => params.row.runId,
  },
  {
    field: 'assignedCount',
    headerName: 'Assigned',
    width: 115,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'noslotCount',
    headerName: 'Unassigned',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'failedCount',
    headerName: 'Failed',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'currentStatus',
    headerName: 'Status',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'totalCaseCount',
    headerName: 'Total Cases',
    width: 130,
    headerAlign: 'left',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'startTime',
    headerName: 'Start Time',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => getFormattedDate(params.row.startTime),
  },
  {
    field: 'endTime',
    headerName: 'Last Updated Time',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => getFormattedDate(params.row.endTime),
  },
]

export const qcLoadBalancerColumns: GridColDef[] = [
  {
    field: 'runId',
    headerName: 'Run ID',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => params.row.runId,
  },
  {
    field: 'totalCaseCount',
    headerName: 'Assigned',
    width: 130,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'currentStatus',
    headerName: 'Status',
    width: 230,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'startTime',
    headerName: 'Start Time',
    width: 240,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => getFormattedDate(params.row.startTime),
  },
  {
    field: 'endTime',
    headerName: 'Last Updated Time',
    width: 240,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => getFormattedDate(params.row.endTime),
  },
]

export const caseDetailsColumns: GridColDef[] = [
  {
    field: 'caseNumber',
    headerName: 'Case Number',
    width: 135,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'caseType',
    headerName: 'Case Type',
    width: 140,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'assigned',
    headerName: 'Assigned',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'noSlot',
    headerName: 'No Slots',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'failed',
    headerName: 'Failed',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
]

export const qcCaseDetailsColumns: GridColDef[] = [
  {
    field: 'caseNumber',
    headerName: 'Case Number',
    width: 425,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'caseType',
    headerName: 'Case Type',
    width: 425,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
  },
]

function getFormattedDateForCaseCount(date) {
  return date.substring(0, 10)
}

function getFormattedDate(date) {
  return moment.tz(date, moment.locale()).format('YYYY-MM-DD HH:mm:ss')?.toString()
}
